<template>
    <BaseCarouselModule v-bind="props" :shoppableImageModule="ShoppableImageModule" />
</template>

<script setup>
import { defineAsyncComponent } from 'vue';

import carouselModuleProps from '~coreModules/contentful/js/carouselModuleProps';

import BaseCarouselModule from '~coreModules/contentful/components/BaseCarouselModule.vue';

const props = defineProps({
    ...carouselModuleProps,
});

const ShoppableImageModule = defineAsyncComponent(() => import(
    /* webpackChunkName: "ShoppableImageModule" */
    '~modules/contentful/components/ShoppableImageModule.vue'),
);
</script>
